export default __webpack_public_path__ + "dda4692.png";